import { Slider } from '@miblanchard/react-native-slider';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import colors, { appTheme } from '@/config/colors';

const styles = StyleSheet.create({
  sliderContainer: {
    flex: 1,
    alignItems: 'stretch',
    justifyContent: 'center',
  },
});

function CustomSlider(props) {
  const responsiveStyles = StyleSheet.create({
    sliderWrapper: {
      flex: 1,
      flexDirection: 'row',
      marginHorizontal: 16,
      alignItems: 'center',
    },
    leftText: {
      fontSize: 16,
      marginRight: 10,
      color: props.disabled ? colors.darkerGrey : appTheme.textColor,
    },
    valueText: {
      marginLeft: 16,
      fontSize: 14,
      color: props.disabled ? colors.darkerGrey : appTheme.textColor,
    },
    rightText: {
      fontSize: 14,
    },
  });

  const [value, setValue] = useState(
    props.initialValue ? props.initialValue : 1,
  );

  useEffect(() => {
    setValue(props.initialValue);
  }, [props.initialValue]);

  const handleChange = (value) => {
    let newValue = Math.floor(value[0]);
    setValue(newValue);
    if (props.returnOnValueChange) {
      props.onValueChange(newValue);
    }
  };

  return (
    <View style={responsiveStyles.sliderWrapper}>
      <View>
        <Text style={responsiveStyles.leftText}>
          {props.title || 'Sekunden'}
        </Text>
      </View>
      <View style={styles.sliderContainer}>
        {props.disabled ? (
          <Slider
            value={value}
            maximumTrackTintColor={colors.grey}
            maximumValue={20}
            minimumTrackTintColor={colors.darkerGrey}
            thumbStyle={responsiveStyles.thumbStyle}
            thumbTintColor={colors.darkerGrey}
            minimumValue={5}
            step={1}
            disabled
          />
        ) : (
          <Slider
            value={value}
            onValueChange={(value) => {
              handleChange(value);
            }}
            maximumTrackTintColor={colors.grey}
            maximumValue={20}
            minimumTrackTintColor={colors.primary}
            thumbStyle={responsiveStyles.thumbStyle}
            thumbTintColor={colors.primary}
            minimumValue={5}
            step={1}
            onSlidingComplete={(value) =>
              props.onSlidingComplete(Math.floor(value))
            }
            trackClickable={true}
          />
        )}
      </View>
      <View style={responsiveStyles.rightText}>
        <Text style={responsiveStyles.valueText}>
          {value} {props.valueUnit}
        </Text>
      </View>
    </View>
  );
}

Slider.propsType = {
  initialValue: PropTypes.number,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  onValueChange: PropTypes.func,
};

export default CustomSlider;
